import { useQuery } from '@tanstack/react-query';

import { GetMyCollectionIdsIncludingArticleApiResponse } from '../apis';

import { clientAxios } from '@/shared/api';
import { ApiResponse } from '@/shared/types';
import { useProfile } from '@/shared/hooks';

export const useMyCollectionIdsIncludingArticleQuery = ({
  articleId,
}: {
  articleId: number;
}) => {
  const { profile } = useProfile();

  return useQuery({
    queryKey: ['getMyCollectionIdsIncludingArticleApi', articleId],
    queryFn: async ({ signal }) => {
      const { data } = await clientAxios.get<
        ApiResponse<GetMyCollectionIdsIncludingArticleApiResponse>
      >('/getMyCollectionIdsIncludingArticleApi/', {
        params: { articleId },
        signal,
      });

      return data.data.ids;
    },
    enabled: !!profile?.yozmitProfileId,
  });
};

export const useGetIsScrappedByArticleId = (articleId: number) => {
  const { data: myCollectionIdsIncludingArticle } =
    useMyCollectionIdsIncludingArticleQuery({
      articleId,
    });

  return (
    myCollectionIdsIncludingArticle &&
    myCollectionIdsIncludingArticle?.length > 0
  );
};
